export const core = {
    limit: 'Has alcanzado el límite de depósitos',
    limitDaily: 'diarios',
    limitWeekly: 'semanales',
    limitMonthly: 'mensuales',
    verified: 'Tu email ha sido verificado exitosamente',
    errorVerified: 'Error al verificar tu email',
    textVerified: {
        1: 'Tu email ha sido verificado exitosamente',
        2: 'Error al verificar tu email',
    },
};